// React wrappers around lib/driveMedia, so pages do not each repeat the same effect.
//
// Both hooks start from an empty result and fill it in when Drive answers. Nothing here
// ever reports an error to the page: a college that cannot be reached looks exactly like a
// college with nothing uploaded yet, and the page shows its built-in photographs instead.

import { useEffect, useState } from "react";
import { EMPTY_MEDIA, fetchAllMedia, fetchCollegeMedia } from "../lib/driveMedia";

export function useCollegeMedia(slug) {
  const [media, setMedia] = useState(EMPTY_MEDIA);

  useEffect(() => {
    let live = true;
    setMedia(EMPTY_MEDIA); // clear the previous college while the new one loads
    fetchCollegeMedia(slug).then((result) => {
      if (live) setMedia(result);
    });
    return () => {
      // Stops a slow reply for the college the visitor has already navigated away from
      // from overwriting the one they are looking at now.
      live = false;
    };
  }, [slug]);

  return media;
}

export function useAllCollegeMedia() {
  const [media, setMedia] = useState(null);

  useEffect(() => {
    let live = true;
    fetchAllMedia().then((result) => {
      if (live) setMedia(result);
    });
    return () => {
      live = false;
    };
  }, []);

  return media;
}
